import { router } from 'ui-utilities';

export default class {
    constructor({
        id,
        actions,
        events,
    }) {
        const el = document.getElementById(id);
        const form = el.querySelector('form');
        const submit = form.querySelector('[type="submit"]');

        function clearUpdatingLabels() {
            // Reset any labels currently marked as 'updating'
            document.querySelectorAll('label.updating').forEach(updatingLabel => {
                updatingLabel.classList.remove('updating');
            });
        }

        function handleSubmit(e) {
            e.preventDefault();

            const formData = new FormData(form);

            submit.setAttribute('disabled', true);

            function cb(res) {
                const {
                    success,
                    lockLocation = false,
                    errors,
                    redirect = '',
                    nextStep,
                } = JSON.parse(res);

                submit.removeAttribute('disabled');

                clearUpdatingLabels();

                if (!success) {
                    // Merge formData w/ errors from controller to update error
                    // text for all inputs from form, sent to controller.
                    const names = [
                        ...Array.from(formData.keys()),
                        ...Object.keys(errors),
                    ];

                    names.forEach(name => {
                        const error = errors[name] || '';

                        events.emit(actions.setInputError, {
                            name,
                            error,
                        });
                    });

                    console.log('errors');

                    window.formErrors = true;

                    return;
                }

                window.formErrors = false;

                if (redirect !== '') {
                    window.location = redirect;
                    return;
                }

                if (lockLocation) {
                    events.emit(actions.lockLocation);
                }

                events.emit(actions.getNextStep, { nextStep });
            }

            router.post({
                formData,
                cb,
            });
        }

        form.addEventListener('submit', handleSubmit);

        form.querySelectorAll('input[type=radio], select').forEach(inputsToMonitor => {
            let hasConditionalInput = false;

            inputsToMonitor.addEventListener('click', event => {
                clearUpdatingLabels();

                console.log('clicked on: ', inputsToMonitor);

                form.querySelectorAll(`div[data-conditional=${inputsToMonitor.name}][data-conditional-value*="${inputsToMonitor.value}"]`).forEach(() => {
                    console.log('found associated conditional - stopping form submission');
                    hasConditionalInput = true;
                });

                if (!hasConditionalInput) {
                    console.log('no remaining conditionals detected - submitting');

                    const { target } = event;
                    const label = target.closest('label');

                    if (label) {
                        label.classList.add('updating');
                    }

                    submit.click();
                }
            });
        });

        const uploadEmulatorButton = document.querySelector('.btn-upload');
        if (uploadEmulatorButton) {
            uploadEmulatorButton.addEventListener('click', () => {
                form.querySelector('input[type=file]').click();
            });
        }
    }
}
